import React from "react";

const Info = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
    >
      <path
        d="M17.5 32.8125C25.9569 32.8125 32.8125 25.9569 32.8125 17.5C32.8125 9.04314 25.9569 2.1875 17.5 2.1875C9.04314 2.1875 2.1875 9.04314 2.1875 17.5C2.1875 25.9569 9.04314 32.8125 17.5 32.8125Z"
        stroke="#3684F3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 17.5V24.0625"
        stroke="#3684F3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 10.9375H17.5146"
        stroke="#3684F3"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Info;
